import { render, staticRenderFns } from "./DocStocks.vue?vue&type=template&id=1d3b8b7b&"
import script from "./DocStocks.vue?vue&type=script&lang=js&"
export * from "./DocStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports